// extracted by mini-css-extract-plugin
export default {"logo":"nHuSJZ","hide":"AV8G6s"};